<template>
  <div v-show="showTag">
    <div class="mask fixed l0 r0 t0 b0"></div>
    <div class="main fixed l0 r0 t0 b0 swiper-container" id="swiper-container">
      <div class="swiper-wrapper">
        <div v-for="(item,index) in urls" class="swiper-slide flex column relative">
          <h3 class="flex0 center relative">
            <span class="color_fff fs16">&nbsp;</span>
            <span class="absolute l45 t0 b0 color_fff fs14" @click="hide">关闭</span>
            <span
              class="absolute r45 t0 b0 color_fff fs14">{{mySwiper&&mySwiper.realIndex?mySwiper.realIndex+1:1}}/{{urls.length}}</span>
          </h3>
          <div class="flex1 flex aic overflow-y-auto">
            <img :src="item.url" alt="" width="100%">
          </div>
          <div v-if="item.description" class="desc absolute fs14 color_fff rgba5 l0 r0 b0 pt20 pb20 pl20 pr20">
            {{item.description}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   *
   */
  export default {
    name: 'photo-sswiper',
    data () {
      return {
        url: '',
urls: [],
        showTag: false,
        mySwiper: null
      }
    },
    created () {

    },
    mounted () {
      this.init()
    },
    methods: {
      show (data) {
        this.showTag = true
        this.url = data.url
        this.urls = data.urls
        setTimeout(this.init, 20)
      },
      hide () {
        this.showTag = false
      },
      init () {
        const el = document.getElementById('swiper-container')
        if (el) {
          if (this.mySwiper !== null) {
            this.mySwiper.update(true)
            this.mySwiper.slideTo(this.urls.findIndex(r => r.url === this.url))
          } else this.mySwiper = new Swiper('#swiper-container', {})
        } else setTimeout(this.init, 20)
      }
    }
  }
</script>

<style scoped lang="scss">
  .mask, .main {
    background-color: black;
    z-index: 1000;
  }

  .swiper-slide {
    h3 {
      line-height: 90px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/photo-sswiper.vue